<template>
  <transition
    :enter-active-class="transitionEnterClass"
    :leave-active-class="transitionLeaveClass"
    name="slide"
    mode="out-in"
  >
    <keep-alive include="Vendors">
      <v-container
        grid-list-md
        fluid
        class="pa-2"
      >
        <router-view
          :key="$route.path"
        />
      </v-container>
    </keep-alive>
  </transition>
</template>

<script>
import pageTransitionMixin from '@/mixins/page-transition-mixin';

export default {
  name: 'Fnb',
  mixins: [pageTransitionMixin],
  data() {
    return {};
  },
  beforeRouteUpdate(to, from, next) {
    this.updatePageTransition(to, from);
    next();
  }
};
</script>
